import React from "react";

import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { ThirdParty } from "Constants/integrationThirdParties";
import { Tooltip } from "ds/Tooltip";
import IntegrationIcon from "src/organization/pages/project/settings/integrations/components/IntegrationIcon";

import * as S from "./IntegrationButton.styles";

type IntegrationButtonProps = {
  integration: ThirdParty;
  displayTooltip?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
};

const IntegrationButton = ({
  integration,
  displayTooltip = true,
  onClick,
  disabled
}: IntegrationButtonProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const { category, type } = integration;

  const handleSelect = (e: React.MouseEvent) => {
    if (onClick) return onClick(e);
    e?.preventDefault();
    navigate(`setup/${type.replace(".", "_")}/configure`);
  };

  const btlEl = (
    <S.Button disabled={disabled} onClick={handleSelect}>
      <IntegrationIcon type={type} />
      <S.Name>{intl.formatMessage({ id: `integration.type.${type}` })}</S.Name>
    </S.Button>
  );

  const integrationBtn = (
    <section>
      {displayTooltip ? (
        <Tooltip
          tooltip={intl.formatMessage({
            id: `integrations.category.${category}`
          })}
          analyticId={`integrations.category.${category}`}
        >
          {btlEl}
        </Tooltip>
      ) : (
        btlEl
      )}
    </section>
  );

  return integrationBtn;
};

export default IntegrationButton;
